module.exports = __webpack_public_path__ + "static/img/14000776.ad5e0741.png";